import React, { useContext, useEffect } from "react";
import Container from "react-bootstrap/Container";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../slices/store";
import FilterSection from "../../user-management/components/FilterSection";
import ReactPaginate from "react-paginate";
import { IUser } from "../../user-management/models/User";
import { setSelectedUser } from "../../../slices/users/userManagementSlice";
import UseAuthConfig from "../../../hooks/useAuthConfig";
import { clientsGet } from "../../../slices/clients/clientManagementSlice";
import { TodosContext } from "../../../context/alert";
import { useNavigate } from "react-router-dom";
import { handleDeleteClientService } from "../service/clientService";
import { Customers } from "../../../slices/clients/types";
import BreadCrumb from "../../../components/organisms/Breadcrumb/BreadCrumb";
import Headline from "../../../components/organisms/Headline/Headline";
import Loader from "../../../components/atoms/Loader/Loader";
import FullWidthCard, {
  CardContentItem,
} from "../../../components/organisms/Cards/full-width-card/FullWidthCard";
import SearchHelper from "../../../components/organisms/Cards/user-card-controller/SearchHelper";
import cardContent from "../../../utils/helpers/helperDataset/client-management-contents/cardContent.json";
import useDebouncedDispatch from "../../../utils/DebouncedDispatch";
import Pagination from "../../../components/molecules/Pagination/Pagination";
interface OptionType {
  value: number;
  label: string;
}

const ListOfClients = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { protectedResources }: any = UseAuthConfig();
  const status = useSelector(
    (state: RootState) => state.clientManagement.status
  );
  const customers = useSelector(
    (state: RootState) => state.clientManagement.clients
  );
  const [requestedUserData, setRequestedUserData] = React.useState<Customers>();
  const [clickFilterStatus, setClickFilterStatus] = React.useState(false);
  const [clickFilterSearch, setClickFilterSearch] = React.useState(false);
  const [paginationChanged, setPaginationChanged] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const { addAlert } = useContext(TodosContext);
  const navigate = useNavigate();
  const [reqRequests, setReqRequest] = React.useState({
    PageNumber: 1,
    SearchText: "",
    SortOrder: 1,
    PageSize: 5,
    OrderBy: "JobTitle",
    ParameterOne: "Active,Inactive,Pending",
    ParameterTwo: "Customer",
    ParameterThree: "",
    url: protectedResources.apiTodoList.endpoint,
    accessToken: localStorage.getItem("AccessToken") || "llll",
  });
  const [selectedOption, setSelectedOption] = React.useState<any>({
    value: 1,
    label: "All",
  });
  const debouncedDispatch = useDebouncedDispatch(dispatch);
  const userStatusData: OptionType[] = [
    { value: 1, label: "All" },
    { value: 2, label: "Active" },
    { value: 3, label: "Inactive" },
  ];

  useEffect(() => {
    setIsLoading(true);
    if (reqRequests) {
      dispatch(clientsGet(reqRequests));
    }
    const storedOption = JSON.parse(
      localStorage.getItem("selectedOptionClients") || "null"
    );
    if (storedOption) {
      setSelectedOption(storedOption);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (customers) {
      setRequestedUserData(customers);
      setIsLoading(false);
    }
  }, [customers]);

  useEffect(() => {
    if (clickFilterStatus || clickFilterSearch || paginationChanged) {
      setIsLoading(true);
      debouncedDispatch(clientsGet, reqRequests);
    }

    return () => {
      debouncedDispatch.cancel();
    };
  }, [
    reqRequests,
    clickFilterStatus,
    clickFilterSearch,
    paginationChanged,
    debouncedDispatch,
  ]);

  const handleSelectedUser = (user: IUser) => {
    dispatch(setSelectedUser(user));
  };

  const handleChangeSelector = (selected: any) => {
    localStorage.setItem("selectedOptionClients", JSON.stringify(selected));
    setSelectedOption(selected);
    handleSetFilterByStatus(selected.label);
  };

  const handleSetFilterByStatus = (data: any) => {
    setClickFilterStatus(true);
    setClickFilterSearch(false);
    if (data === "All") {
      setReqRequest((prevState) => ({
        ...prevState,
        ParameterOne: "Active,Pending,Inactive",
      }));
    } else if (data === "Active") {
      setReqRequest((prevState) => ({
        ...prevState,
        ParameterOne: "Active",
      }));
    } else if (data === "Inactive") {
      setReqRequest((prevState) => ({
        ...prevState,
        ParameterOne: "Inactive",
      }));
    }
  };

  const handleSetFilteredValue = (inputValue: string) => {
    setClickFilterStatus(false);
    setClickFilterSearch(true);
    if (inputValue.length === 0) {
      setReqRequest((prevState) => ({
        ...prevState,
        SearchText: "",
      }));
    } else {
      setReqRequest((prevState) => ({
        ...prevState,
        SearchText: inputValue,
      }));
    }
  };

  const handlePageChange = (event: any) => {
    setPaginationChanged(true);
    setIsLoading(true);
    const { selected } = event;
    setReqRequest((prevState) => ({
      ...prevState,
      PageNumber: selected + 1,
    }));
  };

  const handleDeleteCard = (data: any) => {
    handleDeleteClientService(
      data,
      reqRequests,
      setIsLoading,
      dispatch,
      addAlert,
      false,
      navigate,
      clientsGet,
      protectedResources
    );
  };

  return (
    <Container fluid className="layout-bar">
      <BreadCrumb />

      <Headline
        name="Customers"
        subHeading="View and manage all your customers easily"
      />
      <div className="content-wrapper customer">
        <div className="filter-wrapper">
          <FilterSection
            userStatusData={userStatusData}
            handleSetFilteredValue={handleSetFilteredValue}
            handleSetFilterByStatus={handleSetFilterByStatus}
            selectedOption={selectedOption}
            handleChangeSelector={handleChangeSelector}
          />
        </div>
      </div>

      <div className="content-wrapper customer">
        {isLoading ? (
          <Loader />
        ) : (
          <>
            {customers && customers?.data && customers?.data.length > 0 ? (
              customers?.data.map((user: any, index: number) => (
                <div onClick={(e) => handleSelectedUser(user)} key={index}>
                  <FullWidthCard
                    cardContent={cardContent as CardContentItem[]}
                    key={index}
                    data={user}
                    deleteCard={handleDeleteCard}
                  />
                </div>
              ))
            ) : (
              <SearchHelper
                userdata={requestedUserData}
                isLoading={isLoading}
                filteredValue={[]}
                status={status}
              />
            )}
          </>
        )}
        {customers && customers?.totalPages > 1 ? (
          <Pagination
            pageCount={customers?.totalPages ?? 0}
            pageNumber={reqRequests.PageNumber}
            onPageChange={(page: number) =>
              handlePageChange({ selected: page - 1 })
            }
            totalPages={customers?.totalPages ?? 0}
            pageSize={reqRequests.PageSize}
            totalRecords={customers?.totalRecords ?? 0}
            label="High Intent leads"
          />
        ) : null}
      </div>
    </Container>
  );
};

export default ListOfClients;
